<template>
  <div class="animated fadeIn">
    <div id="custom_backdrop"></div>
    <div class="row pageinfo">
      <b-col cols="4" lg="6">
        <h2 v-show="!trash">Invoice Notifications</h2>
        <h2 v-show="trash">Invoice Notifications - Trash</h2>
      </b-col>   
      <b-col cols="8" lg="6">
      </b-col>
    </div>

    <!-- Filters block-->
    <div class="card">
        <div class="card-body">
            <b-row>
                <b-col order="1" order-md="1" cols="8" sm="6" md="4" lg="2" class="my-1">
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <b-form-input v-model="filter" placeholder="Search" />
                            <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                        </div>
                    </div>
                </b-col>
                <b-col order="2" order-md="1" cols="8" sm="6" md="4" lg="2" class="my-1">
					<b-dropdown class="pull-left" :text="dpdt">
						<b-dropdown-item @click="trash_click()">Active</b-dropdown-item>
						<b-dropdown-item @click="trash_click()">Trash</b-dropdown-item>
					</b-dropdown>
				</b-col>
                <b-col order="3" order-md="5" cols="4" sm="6" md="2" lg="2" class="ml-auto my-1">
                    <b-button class="pull-right" variant="primary" @click="showNewModal()">Add Invoice Notification</b-button>
                </b-col>
            </b-row> 
        </div>

        <!-- Main table block -->
        <div class="card">
            <div class="card-body p-0">
                <!-- Shows when loading data-->
                <b-row v-if="loadingData">
                    <b-col cols="12" sm="12" md="12" lg="12">
                        <p class="text-center"> <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br> Loading data... </p>
                    </b-col>
                </b-row>
                <div v-else class="table-responsive p-0 m-0">
                    <b-table 
                        class="animated fadeIn" 
                        striped 
                        bordered
                        hover 
                        show-empty 
                        stacked="md" 
                        :items="items" 
                        :fields="fields" 
                        :current-page="currentPage" 
                        :per-page="perPage" 
                        @filtered="onFiltered" 
                        :filter="filter"
                        @row-clicked="rowClicked"         
                    >
                        <template  slot="activate" slot-scope="item">
                            <b-form-checkbox disabled id="checkbox" @click.native.stop  :key="item.index" :value="item.activate" v-model="item.item.activate" >
                            </b-form-checkbox>
                        </template>
                    </b-table> 
                </div>
                    <!-- User Interface controls -->
                <div class="table-controls">
                    <b-row>
                        <b-col lg="2" md="2" sm="12" class="my-1 pull-right">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend"> </div>
                                <b-select :options="pageOptions" v-model="perPage" />
                            </div>
                        </b-col>
                        <b-col lg="10" md="10" sm="12" class="my-1">
                            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="mt-0 mb-3 pull-right" />
                        </b-col>
                    </b-row>
                </div>
        <!-- End User Interface controls-->
            </div>
        </div>
    </div>
    <!-- New Invoice Notification Modal -->
    <b-modal class="newHaulModal" ref="newModal" title="New Invoice Notification" v-model="newModal" hide-header-close no-close-on-backdrop no-close-on-esc>
      <b-row>
        <b-col cols="12">
          <b-form-group v-if="role =='super_admin'" :label-cols="4" horizontal label="Trucking Company" label-for="trucking_company">
              <b-form-select :disabled="company_name.length==0" value-field="id" text-field="trucking_company_name" id="trucking_company" v-model="model.trucking_company_id" :options="company_name" @input="selects_trucking_company()"> 
                <template slot="first"><option :value="null" disabled>-- select trucking company --</option></template>
          </b-form-select>
          </b-form-group>
          <b-form-group  :label-cols="4" horizontal label="Energy Company" label-for="energy_company">
            <b-form-select :disabled="energy_companies.length==0" value-field="id" text-field="energy_company_name" id="energy_company" v-model="model.energy_company_id" :options="energy_companies">
              <template slot="first"><option :value="null" disabled>-- select energy company --</option></template>
            </b-form-select>
          </b-form-group>
			    <b-form-group label="Email" label-for="notif2" :label-cols="4" horizontal>
				    <b-form-input type="email" v-model="model.email" class="form-control" @keypress.native="isLowerCaseEmail($event)"/>
			    </b-form-group>	
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100">
        <b-btn size="md" variant="secondary" @click="hideNewModal" class="float-left">Cancel</b-btn>
        <b-btn :disabled="savebtn" size="md" variant="primary" @click="save_click()" class="float-right">Save</b-btn>
      </div>
    </b-modal> 
    <!-- End New Energy Company Modal-->


    <!-- Configure Columns to Display-->

  </div>
</template>

<script>
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2'
  import notification_service from './notification_service'

  Vue.use(VueSweetalert2)
  
  const items = []
  export default {
    name: 'InvoiceNotifications',
    created: function() {
      this.getAll()
    },
    data() {
      return {
        loadingData   : true,
        newModal      : false,
        items         : items,
        totalRows     : items.length,
        currentPage   : 1,
        perPage       : 25,
        pageOptions   : [25, 50, 100],
        trash         : false,
        dpdt          : 'Active',
        role          :'',
        savebtn       :true,
        filter        : null,

        fields: [
        {
          key       : 'id',
          label     : 'Id',
          sortable  : true
        },
        {
          key       : 'energy_company_name',
          label     : 'Energy Company Name',
          sortable  : true
        }, 
        {
          key       : 'trucking_company_name',
          label     : 'Trucking Company Name',
          sortable  : true
        }, 
        {
          key       : 'email',
          label     : 'Email',
          sortable  : true
        },
        ],

        model: {
            id                : null,
            energy_company_id : null, 
            trucking_company_id : null, 
            email             : '',
        },
        company_name    : [],
        energy_companies: [],
      }
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return {
              text: f.label,
              value: f.key
            }
          })
      }
    },
    methods: {
        activate_custom_backdrop() {
            this.$root.$el.classList.add("custom_backdrop_behavior");
        },
        deactivate_custom_backdrop() {
            this.$root.$el.classList.remove("custom_backdrop_behavior");
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        getAll() {
            this.items = []
            notification_service.getAll()
            .then(data => {
                if (data.status == 'success') {
                    this.items            = data.notif.filter(o => o.status_id == (this.trash ? 2 : 1))
                    this.company_name     = data.trucking_companies
                    this.role             = data.role            
                }
                else {
                    this.$swal(data.status, data.message, data.status)
                    this.loadingData = false
                    return
                }
                this.loadingData = false
            })
            .catch(error => {
                Vue.swal('Error', 'Server not response. ' + error, 'error')
                this.loadingData = false
            })
        },
        hideNewModal() {
            this.$refs.newModal.hide()
        },
        showNewModal() {
            this.savebtn        =false    
            this.model.energy_company_id = null 
            this.model.trucking_company_id = null
            this.model.email    = ''
            this.newModal       = true
        },
        okToSave() {

          if (this.model.energy_company_id === undefined || this.model.energy_company_id===null) {
              this.$swal('Alert!', 'Energy Company not selected', 'warning')
              return false
          } else if (this.model.trucking_company_id === undefined || this.model.trucking_company_id===null) {
              this.$swal('Alert!', 'Trucking Company not selected', 'warning')
              return false
          } else if (this.model.email === undefined || this.model.email == '') {
              this.$swal('Alert!', 'Email can not be empty', 'warning')
              return false
          }   
          return true
        },
        save_click() {       
          if (!this.okToSave()) {
            return
          }
          this.savebtn=true
          notification_service.save(this.model)
          .then(data => {
            Vue.swal(data[0], data[1], data[0])
              .then((result) => {
                if (data[0] == 'success') {
                  this.newModal = false
                  this.getAll()
                }
              })
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
          })
          this.savebtn=false
        },
		    isLowerCaseEmail: function(evt) {
			    evt = (evt) ? evt : window.event;
        	var charCode = (evt.which) ? evt.which : evt.keyCode;
			    if ((charCode >= 48 && charCode <= 57) || (charCode >= 97 && charCode <= 122)) {
				    return true
			    } else {
				    if ((charCode == 45) || (charCode == 46) || (charCode == 64) || (charCode == 95) || (charCode == 8) ||  (charCode == 9)) {
					    return true
				    } else {
					    evt.preventDefault();
          	}
			  }
      	},
        rowClicked(row) {
	        if(!this.trash) {
			      this.$router.push('/invoice_haul_notification/' + row.id + "/")
		      } else {
			      this.restore(row.id)
		    }
        },
        trash_click() {
				  this.trash = !this.trash
				  this.dpdt = this.trash ? "Trash" : "Active"
				  this.getAll()
				  this.loadingData = true
        },
        restore(id) {
		      this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to restore this Invoice Notification?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
                    reverseButtons: true
				  }).then((result) => {
					if (result.value) {
						notification_service.restore(id)
							.then(data => {
                                this.$swal(data.status, data.message, data.status)
								if (data.status == 'success') {
									this.filter = ''
									this.trash = false
									this.getAll()
                                    this.loadingData = true
                                    this.dpdt        = 'Active'
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
        },
        selects_trucking_company() {
          let trucking_companies                =  this.company_name
          this.energy_companies                 = []
          this.model.energy_company_id          = null
          if (trucking_companies.length > 0) {
            let trucking_company_index = trucking_companies.map(o => o.id).indexOf(this.model.trucking_company_id)
            if (trucking_company_index > -1) {
              this.energy_companies = trucking_companies[trucking_company_index].energy_companies
            }
          }
        },
  }
}
</script>





// WEBPACK FOOTER //
// src/views/invoices/notifications.vue